import Vue from 'vue'
import { create } from 'vue-modal-dialogs'

import Alert from './common/Alert'
import Confirm from './common/Confirm'
Vue.prototype.$alert = create(Alert, 'title', 'message')
Vue.prototype.$confirm = create(Confirm)

import SearchAndAddCheckpoint from './SearchAndAddCheckpoint'
export let searchAndAddCheckpoint = create(SearchAndAddCheckpoint, 'section')

import NewSoftwareDistribution from './NewSoftwareDistribution'
export let newSoftwareDistribution = create(NewSoftwareDistribution)

import EditSoftwareDistribution from './EditSoftwareDistribution'
export let editSoftwareDistribution = create(EditSoftwareDistribution, 'distro')

import AddStandardToCheckpoint from '@/views/standard/Checkpoint/modals/AddToStandard'
export let addStandardToCheckpoint = create(AddStandardToCheckpoint, 'checkpoint')

import EditSecureSetting from '@/views/standard/Checkpoint/modals/EditSecureSetting'
export let editSecureSetting = create(EditSecureSetting, 'section')

import EditSecondaryScraperPayload from '@/views/scrapers/modals/EditSecondaryScraperPayload'
export let editSecondaryScraperPayload = create(EditSecondaryScraperPayload, 'scraper')